import { ApiClient } from './ApiClient';

export const getUsers = (filter) => ApiClient.get('/users/get-users', { params: { filter } });
export const getRoles = () => ApiClient.get('/users/get-roles');
export const getClientCodes = () => ApiClient.get('/users/get-client-codes');
export const addUser = (payload) => ApiClient.post('/users/add-user', payload);
export const updateUser = (payload) => ApiClient.put('/users/update-user', payload);
export const deleteUser = (payload) => ApiClient.delete('/users/delete-user', { data: payload });
